import styled from "styled-components";
import { mediumSize, secondaryColor } from "../../styles/variables";

const FooterContainer = styled.footer`
    width: 100vw;
    height: 40vh;
    color: black;
    background-color: ${secondaryColor};
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    
    img {
        width: 20vw;
        height: 30vh;
        border-radius: 50%;
    }
    h4 {
        font-size: ${mediumSize};
    }

    
    @media only screen and (max-width: 425px){
        flex-direction: column;
        img {
            width: 38vw!important;
            height: 12vh;
            border-radius: 50%;
        }
    }
    @media only screen and (max-width: 550px){
        flex-direction: column;
        img {
            width: 35vw!important;
            border-radius: 50%;

        }
    }
    @media only screen and (max-width: 950px){
        flex-direction: column;
        img {
            width: 40vw;
            border-radius: 50%;

        }
    }
    @media only screen and (max-width: 1200px){
        flex-direction: column;
        img {
            width: 15vw;
            height: 22vh;
            border-radius: 50%;
        }
    }      

`;

export { FooterContainer }